import { Paper, Typography } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { Line } from "react-chartjs-2";
import DashboardDateRangePicker from "./DashboardDateRangePicker";

// jsonDiaInscrito está keyed por fechaYMD ("YYYY-MM-DD", ver
// DashboardContainer.jsx/services/utils.jsx) — ordenable como string, por
// eso el filtro de rango puede comparar las keys directo sin parsear fechas.
function labelDesdeKey(key, incluirAnio) {
  const [yyyy, mm, dd] = key.split("-");
  return incluirAnio ? `${dd}/${mm}/${yyyy}` : `${dd}/${mm}`;
}

const DashboardRegistryDispersion = ({ jsonDiaInscrito }) => {
  // Por defecto se ve TODO el rango (confirmado con el usuario) — el
  // organizador acota con los selectores si el evento lleva mucho tiempo
  // en inscripciones y el gráfico se vuelve ilegible.
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const todasLasKeys = useMemo(
    () => Object.keys(jsonDiaInscrito || {}).sort(),
    [jsonDiaInscrito]
  );

  const dataDispersion = useMemo(() => {
    // El acumulado sigue sumando desde el inicio real del evento aunque el
    // rango visible esté acotado — así "Acumulado" no se reinicia en falso
    // al hacer zoom a un periodo corto (sería confuso mostrar un acumulado
    // que empieza en 0 a mitad del evento).
    let acumulado = 0;
    const visibles = [];
    const aniosVistos = new Set();

    todasLasKeys.forEach((key) => {
      acumulado += jsonDiaInscrito[key];
      const dentroDeRango =
        (!dateFrom || key >= dateFrom) && (!dateTo || key <= dateTo);
      if (dentroDeRango) {
        visibles.push({ key, cantidad: jsonDiaInscrito[key], acumulado });
        aniosVistos.add(key.slice(0, 4));
      }
    });

    const incluirAnio = aniosVistos.size > 1;

    return {
      datasets: [
        {
          label: "Inscritos por día",
          data: visibles.map((v) => v.cantidad),
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
        {
          label: "Inscritos Acumulados",
          data: visibles.map((v) => v.acumulado),
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
        },
      ],
      labels: visibles.map((v) => labelDesdeKey(v.key, incluirAnio)),
    };
  }, [todasLasKeys, jsonDiaInscrito, dateFrom, dateTo]);

  return (
    <Paper style={{ padding: 20, margin: 5 }}>
      <Typography variant={"h2"} color="primary">
        Dispersión de inscripciones
      </Typography>

      <div style={{ margin: "10px 0 20px" }}>
        <DashboardDateRangePicker
          minDate={todasLasKeys[0]}
          maxDate={todasLasKeys[todasLasKeys.length - 1]}
          dateFrom={dateFrom}
          dateTo={dateTo}
          onChangeDateFrom={setDateFrom}
          onChangeDateTo={setDateTo}
        />
      </div>

      <div className="col s12">
        <Line data={dataDispersion} />
      </div>
    </Paper>
  );
};

export default DashboardRegistryDispersion;
